import fetchIntercept from 'fetch-intercept'
import { getStateLoginComplete } from '../containers/LayoutHome/stateLogin'
import { cookie } from '../util/JWTCookie'


export const unregister = fetchIntercept.register({
  request: function (url, config) {
    if (!config) {
      config = {};
    }
    if (!config.headers) {
      config.headers = {};
    }
    
    const headers = config.headers instanceof Headers 
      ? config.headers 
      : new Headers(config.headers || {});
    
    let userComplete = getStateLoginComplete()    
    let tokenString = cookie.getToken('TrustSafety')    
    if (userComplete?.tenantId) {
      headers.set('tenantId', userComplete.tenantId);
    }
    if (tokenString && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${tokenString}`)
    }
    
    config.headers = headers;
    
    return [url, config]
  },

  requestError: function (error) {
    return Promise.reject(error)
  },

  response: function (response) {
    return response
  },

  responseError: function (error) {
    return Promise.reject(error)
  },
})
